import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnboardingCompanyHomeComponent } from './components/onboarding-company-home/onboarding-company-home.component';

const routes: Routes = [
  {
    path: '',
    component: OnboardingCompanyHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnboardingCompanyRoutingModule {}
